let _suppressShadowSound = false;
let _suppressShadowSoundTimer: ReturnType<typeof setTimeout> | null = null;

export function suppressShadowSound(ms = 200) {
    _suppressShadowSound = true;
    if (_suppressShadowSoundTimer) clearTimeout(_suppressShadowSoundTimer);
    _suppressShadowSoundTimer = setTimeout(() => {
        _suppressShadowSound = false;
        _suppressShadowSoundTimer = null;
    }, ms);
}

export function isShadowSoundSuppressed(): boolean {
    return _suppressShadowSound;
}
